export  const AUTH_TOKEN ='AUTH_TOKEN';
 export  const USER ="USER";


 